<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import solicitacaoReembolsoTerceiroServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import Despesas from './compartilhado/FormDespesas.vue';
  
  export default {
    components: { DadosCadastrais, DadosBancarios, Despesas, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        dadosBancariosPIX: [],
        configuracao: this.$storage.configuracao(),
        arquivos: [],
        desabilitarBeneficiario: false,
        erroArquivos: false,
        usuario: this.$storage.usuario(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Reembolso Terceiro - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-reembolso-terceiro.nova';
    },
    methods: {
      buscaDesabilitarBeneficiario() {
        if (this.configuracao.permissaoAlteracaoNomeBeneficiario != 0)
          return false;

        if (!this.solicitacao.cpf)
          return false;

        return pessoaServico
          .busca(this.solicitacao.cpf)
          .then(pessoa => {
            if (pessoa.nomePessoaFisicaJuridica)
              this.desabilitarBeneficiario = true;
          })
          .catch(error => {
            });
      },
      buscarBeneficiario() {
        $('#avancar').button('loading');

        return pessoaServico
          .busca(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');

            this.solicitacao.cpf = pessoa.cpfCnpj;
            this.solicitacao.nomeRequerinte = pessoa.nomePessoaFisicaJuridica.substring(0, 100);
            this.solicitacao.telefone = pessoa.telefone1;
            this.solicitacao.celular = pessoa.telefone2;
            this.solicitacao.email = pessoa.email.substring(0, 300);
            this.dadosBancarios = pessoa.dadosBancarios;
            this.dadosBancariosPIX = pessoa.dadosBancariosPIX;
            this.solicitacao.endereco = pessoa.endereco ? pessoa.endereco.substring(0, 100) : pessoa.endereco;
            this.solicitacao.numero = pessoa.numero ? pessoa.numero.substring(0, 10) : pessoa.numero;
            this.solicitacao.complemento = pessoa.complemento ? pessoa.complemento.substring(0, 80) : pessoa.complemento;
            this.solicitacao.bairro = pessoa.bairro ? pessoa.bairro.substring(0, 80) : pessoa.bairro;
            this.solicitacao.cidade = pessoa.cidade ? pessoa.cidade.substring(0, 60) : pessoa.cidade;
            this.solicitacao.uf = pessoa.estado;
            this.solicitacao.cep = pessoa.cep;
            this.solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);

            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
            this.buscaDesabilitarBeneficiario();
          })
          .catch(error => {
            $('#avancar').button('reset');
            
            this.solicitacao.cpf = this.documento;

            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      camposSolicitacao() {
        return {
          idProjeto: null,
          idConta: '',
          nomeRequerinte: '', 
          cpf: '', 
          email: null, 
          telefone: '', 
          celular: '', 
          agencia: '', 
          banco: '', 
          conta: '', 
          tipoConta: '',
          tipoPix: '',
          chavePix: '',
          despesas: [],
          compraDireta: null, 
          dataNascimento: '', 
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          cep: null,
          uf: '', 
          projeto: {
            nomeProjeto: '',
            valorLimiteCompraDireta: 0.0,
            permiteUtilizarCompraDireta: false,
            utilizarMetaEtapaProjeto: false,
          }
        }
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolReembolsoTerceiro || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolReembolsoTerceiro.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      mostrarInstrucoesCompraDireta() {
        return;

        if (!this.configuracao.observacaoCompraDiretaReembolso)
          return;

        if (!this.usuario.permissoes.solCompraDireta)
          return;

        if (!this.solicitacao.rateio.projeto.permiteUtilizarCompraDireta)
          return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.observacaoCompraDiretaReembolso.replace(/\r\n/g, '<br>'),
          type: 'success',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      salvar() {
        $('#salvar').button('loading');

        this.$refs.dadosCadastrais
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.$refs.dadosBancarios.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-bancarios"]').tab('show');
              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.validarArquivos)
          .then(valido => {
            if (!valido) {
              this.erroArquivos = true;
              $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');
            }

            return valido;
          })
          .then(this.validarSePossuiDespesa)
          .then(this.validarCompraDireta)
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-reembolso-terceiro.relatorio', id, 'solicitacao-reembolso-terceiro');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            if (!this.erroArquivos) {
              this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
            }

            this.erroArquivos = false;
          });
      },
      validarSePossuiDespesa(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.solicitacao.despesas.length > 0) return true;

        $('#tabs a[href="#tab-despesas"]').tab('show');
        
        this.$swal(
          '',
          'A solicitação deve possuir ao menos uma despesa.',
          'info'
        );

        throw new Error("validacao");
      },
      validarCompraDireta(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.solicitacao.compraDireta)
          return true;

        var valorLimiteCompraDireta = 0;
        var valorSolicitacao = 0;

        if (this.solicitacao.projeto.valorLimiteCompraDireta)
          valorLimiteCompraDireta = this.$options.filters.formatarNumero(this.solicitacao.projeto.valorLimiteCompraDireta, true);

        if (this.solicitacao.despesas[0].valor)
          valorSolicitacao = this.$options.filters.formatarNumero(this.solicitacao.despesas[0].valor, true);

        if ((valorSolicitacao - valorLimiteCompraDireta) <= 0) return true;

        this.$swal(
          '',
          'O valor da solicitação de compra direta está limitado a um valor de até ' + `R$ ${this.$options.filters.formatarNumero(valorLimiteCompraDireta)}`,
          'info'
        );

        $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
        throw new Error("validacao");
      },
      validarArquivos() {
        if (this.configuracao.obrigatorioArquivoSolReembolsoTerceiro) {
          const faltaArquivo = !this.$refs.adicionarArquivos.existeArquivo();

          if (this.arquivos.length === 0 && faltaArquivo) {
            var texto = "Adicione pelo menos um arquivo na solicitação! <br>";

            this.$swal({
              title: 'Falta de Arquivos',
              html: texto,
              type: 'error',
              confirmButtonText: 'Ok, entendi!',
              allowOutsideClick: false,
              allowEscapeKey: false,
            });

            return false;
          }
        }
        return true;
      },

      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        const arquivos = this.$refs.adicionarArquivos.arquivos;

        if (this.$route.params.id) {
          return solicitacaoReembolsoTerceiroServico.alterar(copiaSolicitacao, arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoReembolsoTerceiroServico.adicionar(copiaSolicitacao, arquivos);
        }
      },
      download(arquivo) {
        solicitacaoReembolsoTerceiroServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoReembolsoTerceiroServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => {
            return this.carregarDadosBancarios(solicitacao.cpf);
          })
          .then(() => {
            return this.carregarDadosBancariosPIX(solicitacao.cpf);
          })
          .then(() => solicitacaoReembolsoTerceiroServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => this.$refs.dadosCadastrais.listaContas(solicitacao.idProjeto))
          .then(() => this.listaDeRubricas(solicitacao.idProjeto))
          .then(() => {
            solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(solicitacao.dataNascimento);
            this.$set(this, 'solicitacao', solicitacao);
            this.buscaDesabilitarBeneficiario();
            this.$refs.despesas.desabilitarCompraDireta(solicitacao);
            if (solicitacao.tipoConta != null)
              this.$refs.dadosBancarios.setarTipoBancario(parseInt(solicitacao.tipoConta));
            this.carregando = false;
          });
      },
      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
      carregarDadosBancariosPIX(cpf) {
        return pessoaServico
          .dadosBancariosPIX(cpf)
          .then(dadosBancarios => {
            this.dadosBancariosPIX = dadosBancarios;
          })
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
      listaDeRubricas(idProjeto) {
        if (!idProjeto) return;

        if (!this.exibirRubricaSubrubricaSolicitacaoWeb) return;

        if (this.solicitacao.projeto.utilizarMetaEtapaProjeto) {
          this.$refs.despesas.listaDeMetaEtapas(idProjeto);
        } else {
          this.$refs.despesas.listaDeRubricas(idProjeto);
        }
      },
      exibirRubricaSubrubricaSolicitacaoWeb() {
        return this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || this.solicitacao.projeto.utilizarRubricaSubrubricaWeb;
      }
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">

        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>
        </div>

        <div class="tabs-container" v-show="!carregando" id="tabs">

          <ul class="nav nav-tabs">
            <li class="active">
              <a
                data-toggle="tab"
                href="#tab-dados-cadastrais">
                Dados cadastrais
              </a>
            </li>
            <li>
              <a
                data-toggle="tab"
                href="#tab-dados-bancarios">
                Dados bancários
              </a>
            </li>
            <li>
              <a
                data-toggle="tab"
                href="#tab-despesas">
                Despesas
              </a>
            </li>
            <li v-if="configuracao.usarArquivosSolicitacaoReembolsoTerceiro">
              <a
                data-toggle="tab"
                href="#tab-adicionar-arquivos">
                Adicionar arquivos
              </a>
            </li>
            <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoReembolsoTerceiro">
              <a
                data-toggle="tab"
                href="#tab-lista-arquivos">
                Arquivos
              </a>
            </li>
          </ul>
          <div class="tab-content">

            <div id="tab-dados-cadastrais" class="tab-pane active">
              <div class="panel-body">
                <dados-cadastrais
                  ref="dadosCadastrais"
                  :solicitacao="solicitacao"
                  :desabilitarBeneficiario="this.desabilitarBeneficiario"
                  :edicao="!!$route.params.id"
                  @projetoAlterado="listaDeRubricas">
                </dados-cadastrais>
              </div>
            </div>

            <div id="tab-dados-bancarios" class="tab-pane">
              <div class="panel-body">
                <dados-bancarios ref="dadosBancarios"
                                 :solicitacao="solicitacao"
                                 :edicao="!!$route.params.id"
                                 :dadosBancarios="dadosBancarios"
                                 :dadosBancariosPIX="dadosBancariosPIX">
                </dados-bancarios>
              </div>
            </div>

            <div id="tab-despesas" class="tab-pane">
              <div class="panel-body">
                <despesas
                  ref="despesas"
                  :solicitacao="solicitacao"
                  :edicao="!!$route.params.id">
                </despesas>
              </div>
            </div>

            <div id="tab-adicionar-arquivos" class="tab-pane">
              <div class="panel-body">
                <adicionar-arquivos
                  ref="adicionarArquivos">
                </adicionar-arquivos>
              </div>
            </div>

            <div id="tab-lista-arquivos" class="tab-pane">
              <div class="panel-body">
                <lista-de-arquivos
                  :arquivos="arquivos"
                  @download="download"
                  ref="listaArquivos">
                </lista-de-arquivos>
              </div>
            </div>
            
          </div>
          
        </div>
        
      </div>

      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">CPF do Beneficiário</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="documento"
                   data-vv-as="documento"
                   data-vv-name="documento"
                   v-mascara="'cpf'"
                   v-validate="'required|cpf'">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link
              class="btn btn-default"
              :to="{ name: 'solicitacao-reembolso-terceiro' }"
              v-show="!mostrarFormulario || !!$route.params.id"
              active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
              id="avancar"
              type="button"
              class="btn btn-primary"
              @click="validarBeneficiario"
              v-show="!mostrarFormulario"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar
              <i class="fa fa-arrow-right"></i>
            </button>

            <button
              type="button"
              class="btn btn-default"
              @click="mostrarFormulario = false, resetarComponente()"
              v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta
            </button>

            <button
              id="salvar"
              type="button"
              class="btn btn-primary"
              @click="salvar"
              v-show="mostrarFormulario"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-terceiro/componentes/SolicitacaoReembolsoTerceiroForm.vue